'use strict';

const Classnames = require('classnames');
const isNode = typeof document === 'undefined';
const React = require('react');

const Constants = require('../constants/');
const Forms = require('../forms/');

if (!isNode) {
    require('./fulloffice-banner.scss');
}

const FullOfficeBanner = React.createClass({
    render: function() {
        const classes = Classnames({
            'fo-banner': true,
            'fo-banner-includeButton': this.props.includeButton,
        });
        const img = this.props.includeButton ? 'fo-banner.jpg' : 'cover1.jpg';
        return (
            <div className={classes}>
                <img className='fo-banner-img' src={`${Constants.static}/images/fulloffice/${img}`} />
                <div className='fo-captions'>
                    <h1>FURNISHING AN ENTIRE OFFICE?</h1>
                    <h2>In 3 quick steps you'll have an instant Budget Estimate and an experienced team to help you build your dream office.</h2>

                    {this.props.includeButton ?
                        <Forms.Button type      = 'next'
                                      label     = 'LEARN MORE'
                                      link      = '/budget-your-office'
                                      external  = {true}
                                      theme     = 'dark'/>
                    : null}
                </div>
            </div>
        );
    }
})

module.exports = FullOfficeBanner;



// WEBPACK FOOTER //
// ./src/components/fulloffice-banner.jsx